import React,{Component} from 'react';
import {Modal,Button,Row,Col,Form} from 'react-bootstrap';
import axios from 'axios';

export  class EditTechnologyModal extends Component{
    constructor(props){
        super(props);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.state = {
            DomainList:[]
        }
      

    }
    componentDidMount() {
        this.getdomain();
      ///  if(this.props.defaultrequired = 1)
      ///  {
      ///      document.getElementById('divdefault').style.display = 'block';
     ///   }
     ///   else
     ///   {
     ///       document.getElementById('divdefault').style.display = 'none';
     ///   }
        
    }  
    
    ServiceGroupchange(e) {
        if(e.target.value == 'IE')
        {
            document.getElementById('divDomain').style.display = 'block';
        }
        else
        {
            document.getElementById('divDomain').style.display = 'none';
        }

    }
 
    getdomain() {
        fetch("https://as-mobilization.accenture.com/KTPlanConfig/api/Index/Domains/"+2).then(response => response.json())
        .then(res=> {            
          this.setState ( { DomainList: res } )
            })
            .catch(err => {
              console.log(err);
          }) 
      }
      closeButtonClickHandler = () => {
        this.props.Close();
      }
    handleSubmit(event){
        event.preventDefault();
        const options = {
            headers: {"content-type": "text/plain"}
        }
    const article = {technologyid:event.target.technologyid.value, technology:event.target.Technology.value, DomainId:event.target.Domain.value,Servicegroup:'AO',username:this.props.username,DomainName:' ',Technologydefault:event.target.Technologydefault.value  };
    axios.post('https://as-mobilization.accenture.com/KTPlanConfig/api/AdminTechnology/Post', article, options)
    .then(res=> { 
        this.setState ( { msg: res.data} )
           console.log(res);
           alert(res.data);
          })
          .catch(err => {
            console.log(err);
        }) 
       
          
    }

    render(){
        return (
            <div className='container'>
            <Modal  {...this.props} size='lg'  aria-labelledby='contained-modal-title-vcenter' centered >
                <Modal.Header>
                <Modal.Title id='contained-modal-title-vcenter'>
                    Edit Technology
                </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Row>
                        <Col sm={12}>
                          <Form onSubmit={this.handleSubmit}>
                          <Form.Group controlId='technology'>
                              <div style={{display:'none'}}>
                              <Form.Label>Technology Id</Form.Label>
                              <Form.Control type='text' style={{width:140}} name='technologyid' required
                              disabled defaultValue={this.props.TechnologyId} placeholder='Technology'></Form.Control>
                              </div>
                           
                              
                          </Form.Group> 

                          <Form.Group controlId='technology'>
                              <div>
                              <Form.Label>Technology*</Form.Label>
                              <Form.Control type='text' maxLength={100} style={{width:140}} defaultValue={this.props.Technology} name='Technology' required placeholder='Technology'></Form.Control>
                              </div>
                            
                              <div  style={{display:(this.props.DomainId == '' || this.props.DomainId == 0)?'none':'block'}}  id='divDomain'>
                              <Form.Label>Domain</Form.Label>
                              <Form.Select className='form-control' id='ddlDomain' defaultValue={this.props.DomainId} style={{width:140}} name='Domain'>
                              <option value='Select'>Select</option>
                  
                                    {
                                    
                                    this.state.DomainList.map(list =>
                                            <option value={list.value} >{list.text}</option>)
                                    }
                              </Form.Select>
                              </div>

                             
                                  <div id='divdefault' style={{display:this.props.defaultrequired==1?'block':'none'}} >
                                  <Form.Label>Default Technology/Tower</Form.Label>
                                  <Form.Select className='form-control'   id='ddlTechnology' defaultValue={this.props.Default} style={{width:140,display:'block'}} name='Technologydefault'>
                                   
                                  
                                  <option value='Select'>Select</option>
                      
                                        {
                                        this.props.techlist.map(list =>
                                                <option value={list.value} >{list.text}</option>)
                                        }
                                  </Form.Select>
                             
                                  </div>
                              
                          </Form.Group>  
                          <Form.Group>
                              <Button variant='primary' style={{margin:10,width:100}} className='btn-new btn-confirm' type='submit'>
                                  Save
                              </Button> 
                              <Button onClick={this.props.onHide} style={{margin:10,backgroundColor:'gray'}} className='btn-new btn-confirm'>Close
                              </Button>
                          </Form.Group>  
                          </Form>  
                        </Col>
                    </Row>
                </Modal.Body>
               
            </Modal>
            </div>
        )
    }
}